export default "__VITE_ASSET__CWF_7eVD__"